export default __webpack_public_path__ + "static/media/device_led_off.2e42c5ff.svg";